import { useEffect, type RefObject } from "react";

export function useParallax(
  hostRef: RefObject<HTMLElement>,
  visualRef: RefObject<HTMLElement>,
  strength = 18
) {
  useEffect(() => {
    const host = hostRef.current;
    const visual = visualRef.current;
    if (!host || !visual) return;

    const layers = visual.querySelectorAll<HTMLElement>("[data-parallax-depth]");
    if (!layers.length) return;

    let tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;

    function onMove(e: MouseEvent) {
      const r = visual!.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
    }
    function onLeave() { tx = 0; ty = 0; }

    visual.addEventListener("mousemove", onMove);
    visual.addEventListener("mouseleave", onLeave);
    host.addEventListener("mousemove", onMove);
    host.addEventListener("mouseleave", onLeave);

    function tick() {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      layers.forEach((l) => {
        const d = parseFloat(l.dataset.parallaxDepth || "1");
        l.style.transform = `translate3d(${(cx * d * strength).toFixed(2)}px, ${(cy * d * strength).toFixed(2)}px, 0)`;
      });
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      visual.removeEventListener("mousemove", onMove);
      visual.removeEventListener("mouseleave", onLeave);
      host.removeEventListener("mousemove", onMove);
      host.removeEventListener("mouseleave", onLeave);
    };
  }, [hostRef, visualRef, strength]);
}

